<template>
  <div id="points" class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>团购</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      class="banner"
      v-bind:style="{backgroundImage:'url(' + serve + banner + ')'}"
    ></div>

    <div class="box b2" style="margin-top:20px;">
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item,index) of data" :key="index">
          <div class="item">
            <el-card :body-style="{ padding: '0px' }">
              <img :src="serve  +_.split(item.images, ';', 1)" class="cover">
              <div style="text-align:center">
                <div class="t1 lv2Text">
                  {{_.truncate(item.title, {
                  'length': 15,
                  'separator': ' ...'
                  })}}
                </div>
                <div class="t3 lv0Text">
                  <s class="lv3Text">原价 &yen;{{item.selling_price}}</s>
                  <span class="lv0Text" style="margin-left:10px;">团购价 &yen;{{item.g_price}}</span>
                </div>
                <div class="t2">
                  <el-button round size="small" @click="go(item.group_id)">立即拼团</el-button>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
       serve: this.$store.state.serve,

      data: {},
      banner: ""
    };
  },
  activated(){
    this.$store.commit('set_top_nav' , '3')
  },
  created() {
    this.initData();
  },
  methods: {
    //
    go(id) {
      this.$router.push("/viewGroup?id=" + id);
    },
    reload() {
      this.axios
        .get(this.serve + "/groupBuy", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: this.page,
            upper: this.max,
            lower: this.min,
            key: this.keywords,
            sort: this.orderBy
          }
        })
        .then(res => {
          this.data = res.data.data.results;
          this.total = res.data.data.total;
        });
    },
    pageChange(v) {
      this.page = v;
      this.reload();
    },
    search() {
      this.reload();
    },
    initData() {
      this.axios
        .get(this.serve + "/get_banner?type=group")
        .then(res => {
          this.banner = res.data.data.image;
        });
      this.axios.get(this.serve + "/groupBuy").then(res => {
        this.data = res.data.data.results;
        this.total = res.data.data.total;
      });
    }
  }
};
</script>
<style lang="scss">
#points {
  .item {
    background-color: #ffe5e8;
  }
  .t2 {
    padding: 20px 0;
  }
  .t1 {
    padding: 20px 0 20px 0;
    border-bottom: 1px solid #ddd;
  }
  .t3 {
    margin-top: 10px;
  }
  .cover {
    display: block;
    width: 273px;
    height: 273px;
  }
  padding-bottom: 40px;
  .item {
    margin-bottom: 20px;
  }
  .i1 {
    margin-right: 8px;
    padding: 3px 10px;
    cursor: pointer;
  }
  .el-input-group__append {
    background-color: #e2211c;
    color: #fff;
  }
  .i1.active {
    background-color: #e2211c;
    color: #fff;
    border-radius: 8px;
  }
  .banner {
    margin-bottom: 20px;
    height: 350px;
    width: 1200px;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 10px 20px;
  }
  .box.b2 {
    padding-top: 40px;
    padding-bottom: 50px;
    border: 0;
  }
}
</style>